export const ROLE_CAPABILITIES = {
  IT_ADMIN: {
    allScreens: true,
    canEdit: true,
    canDelete: true,
    canCreate: true,
    isEditTan: true
  },
  null: {
    allScreens: false,
    canEdit: false,
    canDelete: false,
    canCreate: false,
    isEditTan: false
  },
  PREPARER: {
    allScreens: false,
    canEdit: false,
    canDelete: false,
    canCreate: true,
    isEditTan: true
  },
  ADMIN: {
    allScreens: true,
    canEdit: true,
    canDelete: false,
    canCreate: false,
    isEditTan: true
  },
  default: {
    allScreens: false,
    canEdit: false,
    canDelete: false,
    canCreate: false,
    isEditTan: true
  },
};


export const userTypes = {
  IT_ADMIN : 'IT_ADMIN',
  ADMIN : 'ADMIN',
  PREPARER : 'PREPARER'
}
export const IT_ADMIN = 'IT_ADMIN';
export const ADMIN = 'ADMIN';
export const PREPARER = 'PREPARER';